// extracted by mini-css-extract-plugin
export var additionalAction = "messenger-module--additional-action--23680";
export var additionalActionText = "messenger-module--additional-action-text--12401";
export var additionalActionsWrapper = "messenger-module--additional-actions-wrapper--dc4cc";
export var form = "messenger-module--form--7a2c9";
export var input = "messenger-module--input--c4794";
export var loading = "messenger-module--loading--f1d2d";
export var paperClip = "messenger-module--paper-clip--66d72";
export var submitButton = "messenger-module--submit-button--ac9b0";
export var submitButtonHolder = "messenger-module--submit-button-holder--e56b7";
export var textarea = "messenger-module--textarea--1cd01";